import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';

interface IValidateDataProps {
    category: string; // Social Security Number, Tax Id Number -- can add more as needed
    submitValue: (val: string) => void;
    closePanel: () => void;
}

class ValidateForm {
    initial: string;
    validate: string;
}

const ValidateDataPanel = (props: IValidateDataProps) => {
    const [errorMessage, setErrorMessage] = useState<string>('');
    const { handleSubmit, register, errors } = useForm();

    const submitData = (value: string) => {
        props.submitValue(value);
        console.log('submitting this value: ', value);
        props.closePanel();
    };

    const validateData = (data: ValidateForm) => {
        const ssnPattern = /^(?!666|000|9\d{2})\d{3}-(?!00)\d{2}-(?!0000)\d{4}$/;
        const altSsnPattern = /^(?!666|000|9\d{2})\d{3}(?!00)\d{2}(?!0000)\d{4}$/;
        const einPattern = /^\d{2}-\d{7}$/;
        const altEinPattern = /^\d{9}$/;

        if (props.category === 'Social Security Number') {
            if ((!ssnPattern.test(data.initial) && !altSsnPattern.test(data.initial)) || (!ssnPattern.test(data.validate) && !altSsnPattern.test(data.validate))) {
                setErrorMessage('*Social security number must match this pattern: xxx-xx-xxxx or be 9 digits long');
                return;
            }
        }

        if (props.category === 'Tax Id Number') {
            if ((!einPattern.test(data.initial) && !altEinPattern.test(data.initial)) || (!einPattern.test(data.validate) && !altEinPattern.test(data.validate))) {
                setErrorMessage('*Federal tax id must match this pattern: xx-xxxxxxx or be 9 digits long');
                return;
            }
        }
        
        if (data.initial === data.validate) {
            submitData(data.initial);
            setErrorMessage('');
        } else {
            setErrorMessage('*Values must match');
        }
    };

    return (
        <div>
            <div
                style={{
                    borderBottom: '1px solid #ccc',
                    margin: '-.5rem -.5rem 1rem -.5rem',
                    background: '#EFF4F8',
                    display: 'flex',
                    justifyContent: 'left'
                }}
            >
                <h2 style={{ color: '#6393C1', padding: '.5rem 1rem', margin: '0' }}>{`Validate ${props.category}`}</h2>
            </div>
            <div className="mb-2">
                <form onSubmit={handleSubmit(validateData)}>
                    <p style={{ color: 'red' }}>{errorMessage}</p>
                    <RHFInputBox
                        name={'initial'}
                        label={'Enter value'}
                        labelOnLeft={true}
                        register={register}
                        errors={errors}
                        onPaste={(e) => {
                            e.preventDefault();
                        }}
                    />
                    <RHFInputBox
                        name={'validate'}
                        label={'Re-enter value'}
                        labelOnLeft={true}
                        register={register}
                        errors={errors}
                        onPaste={(e) => {
                            e.preventDefault();
                        }}
                    />
                </form>
            </div>
            <div className="button-row" style={{ paddingBottom: '1rem' }}>
                <Button text="Save" onClick={handleSubmit(validateData)} intent="primary" />
                <Button text="Cancel" onClick={props.closePanel} intent="secondary" />
            </div>
        </div>
    );
};

export default ValidateDataPanel;


// WEBPACK FOOTER //
// ./src/components/personnel/dialogs/taxInfo/ValidateEntryPanel.tsx